import {animateInViewport} from './transition'

let jQueryBridget = require('jquery-bridget')
let Masonry = require('masonry-layout')

jQueryBridget('masonry', Masonry, $)

$(function () {
  window.msnry = $('.masonry')
    .on('layoutComplete', function () {
      animateInViewport()
    })
    .masonry({
      itemSelector: '.masonry-item',
      gutter: 0,
      columnWidth: '.masonry-item:not(.hidden):not(.filtered)',
      transitionDuration: 0,
      horizontalOrder: true,
    })
})

let resizeTimer

$(window).on('resize', function () {
  clearTimeout(resizeTimer) // Clear the previous timer

  resizeTimer = setTimeout(function () {
    // Your code to be executed after 100ms of inactivity
  }, 100)
})
